export const css = {
    root: '_2TvXhcEx',
    ' _key': 'afcpe-theme/afcpe/lcc-app/content'
};
export default css;
